"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@fluentui/react");
var clsx_1 = __importDefault(require("clsx"));
require("./LayoutContent.scss");
exports.LayoutContent = function (props) {
    var className = props.className, loading = props.loading, children = props.children, contentClassNameProps = props.contentClassName, rightPanel = props.rightPanel, rightPanelClassNameProps = props.rightPanelClassName;
    var layoutClassName = clsx_1.default(className, 'eta-layout-content-root');
    var contentClassName = clsx_1.default('layout-content', rightPanel ? 'withRightPanel' : '', contentClassNameProps);
    var sidePanelClassName = clsx_1.default('layout-rightPanel', rightPanelClassNameProps);
    return (react_1.default.createElement("div", { className: layoutClassName },
        loading &&
            react_1.default.createElement(react_2.ProgressIndicator, { className: 'LoadingIndicator' }),
        !loading &&
            react_1.default.createElement("div", { className: 'LoadingIndicator' }),
        react_1.default.createElement("div", { className: clsx_1.default('eta-layout-content', rightPanel ? 'srollable' : '') },
            react_1.default.createElement("div", { className: contentClassName }, children),
            rightPanel && (react_1.default.createElement("div", { className: sidePanelClassName }, rightPanel)))));
};
//# sourceMappingURL=LayoutContent.js.map